import { render, staticRenderFns } from "./VFairDetails.vue?vue&type=template&id=79c8fc45&scoped=true&"
import script from "./VFairDetails.vue?vue&type=script&lang=ts&"
export * from "./VFairDetails.vue?vue&type=script&lang=ts&"
import style0 from "./VFairDetails.vue?vue&type=style&index=0&id=79c8fc45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c8fc45",
  null
  
)

export default component.exports